import { inject } from '@angular/core';
import { PassportForCareService } from '@web/csl-lib-services';
import { PassportForCareState } from './passport-for-care.state';
import { PassportForCareStatusDto } from '@web/csl-lib-models';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { pipe, switchMap, tap } from 'rxjs';
import { rxMethod } from '@ngrx/signals/rxjs-interop';

const initialState: PassportForCareState = {
  healthRecordId: '',
  status: null,
  isLoading: false,
  error: null
};

export const PassportForCareStore = signalStore(
  withState(initialState),
  withMethods((store, pfcService = inject(PassportForCareService)) => ({
    loadStatus: rxMethod<string>(
      pipe(
        switchMap((healthRecordId: string) => {
          patchState(store, { isLoading: true, healthRecordId });
          return pfcService.getStatus(healthRecordId).pipe(
            tap({
              next: (status: PassportForCareStatusDto) => {
                //FOR TESTING:  status.scpNeedsUpdate = false;
                patchState(store, { status, isLoading: false, error: null });
              },
              error: (e) => {
                console.error('[PfcStore] Error loading status:', e);
                patchState(store, {
                  status: null,
                  isLoading: false,
                  error: e.message || 'Failed to load PFC status'
                });
              }
            })
          );
        })
      )
    ),
  }))
);
